import { createReducer, on } from "@ngrx/store";
import { resetSelectedObject, selectObject, setObjects, setSelectedProductPrice } from "./objects.actions";
import { IObject, IObjectsState } from "./objects.models";

export const initialState: IObjectsState = { selected: null, list: [] };

export const objectsReducers = createReducer(
    initialState,
    on(setObjects, (state, { objects }) => { return { ...state, list: objects } }),
    on(selectObject, (state, { object }) => { return { ...state, selected: object } }),
    on(setSelectedProductPrice, (state, {selectedProductPrice}) => { 

        const selectedProduct = JSON.parse(JSON.stringify(state.selected)) as IObject;
        selectedProduct.selectedProductPrice = selectedProductPrice;

        return { ...state, selected: selectedProduct}
    }),
    on(resetSelectedObject, (state) => initialState)
);